import React from 'react'
import createMeasurement from '../Measurements'
import { scaleTime, scaleLinear } from 'd3-scale'
import { axisBottom, axisLeft } from 'd3-axis'
import { Axis } from 'integ-graphs'
// import { line } from 'd3-shape'
import { max, min } from 'd3-array'
import R from 'ramda'
// import styled from 'styled-components'
import Today from './TimeSeriesToday'
// import ActualLayer from './ActualLayer'
import PredictedLayer from './PredictedLayer'
import MonthSelection from './MonthSelection'
import moment from 'moment'
import HoverIndicator from './HoverIndicator'

const calculateDomainInfo = ({
  minDate,
  maxDate,
  maxValue,
  minValue,
  data,
}) => ({
  minDate: R.isNil(minDate) ? min(data, d => d.metricDate) : minDate,
  maxDate: R.isNil(maxDate) ? max(data, d => d.metricDate) : maxDate,
  maxValue: R.isNil(maxValue) ? max(data, d => d.value) : maxValue,
  minValue: R.isNil(minValue) ? min(data, d => d.value) : minValue,
})

const normalizeDate = v =>
  R.isNil(v) ? undefined : typeof v === 'string' ? new Date(v) : v

const normalzieForcastDates = R.map(d => ({
  ...d,
  date: normalizeDate(d.date),
  metricDate: normalizeDate(d.metricDate),
  recordDate: normalizeDate(d.recordDate),
}))

class TimeSeriesForecast extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      recordDate: moment()
        .startOf('month')
        .toDate(),
      hoverDate: undefined,
    }
    this.selectDate = this.selectDate.bind(this)
    this.hoverDate = this.hoverDate.bind(this)
  }

  selectDate(recordDate) {
    if (recordDate.getTime() <= new Date().getTime())
      this.setState({ recordDate })
  }

  hoverDate(hoverDate) {
    this.setState({ hoverDate })
  }

  render() {
    const { measurement = createMeasurement({}), ...rest } = this.props
    const { recordDate, hoverDate } = this.state

    const { margin, innerHeight } = measurement
    let data = normalzieForcastDates(rest.data)
    const domainInfo = calculateDomainInfo({
      ...rest,
      data,
    })
    const { minDate, maxDate, maxValue, minValue } = domainInfo
    data = data.filter(d => d.metricDate.getTime() <= maxDate.getTime())

    const xScale = scaleTime()
      .domain([minDate, maxDate])
      .range([0, measurement.innerWidth])

    const yScale = scaleLinear()
      .domain([minValue, maxValue])
      .range([measurement.innerHeight, 0])

    return (
      <g transform={`translate(${margin.left},${margin.top})`}>
        <HoverIndicator
          {...domainInfo}
          xScale={xScale}
          yScale={yScale}
          hoverDate={hoverDate}
        />
        <MonthSelection
          {...domainInfo}
          xScale={xScale}
          yScale={yScale}
          recordDate={recordDate}
          selectDate={this.selectDate}
          hoverDate={this.hoverDate}
        />
        <Axis dy={innerHeight} axis={axisBottom(xScale)} />
        <Axis axis={axisLeft(yScale)} />
        {/* <ActualLayer
          {...domainInfo}
          xScale={xScale}
          yScale={yScale}
          data={data}
        /> */}
        <PredictedLayer
          recordDate={undefined /* recordDate */}
          {...domainInfo}
          xScale={xScale}
          yScale={yScale}
          data={data}
        />
        <Today {...domainInfo} xScale={xScale} yScale={yScale} />
      </g>
    )
  }
}

export default TimeSeriesForecast
